import React from 'react';
import { NavLink } from 'react-router-dom';

class AboutCompany extends React.Component {
    render() {
        return (
            <>
                <div className="section-full p-t80 bg-white text-dark">
                    <div className="container">
                        <div className="section-content ">
                            <div className="m-service-containt text-dark">
                                <div className="row">
                                    <div className="col-md-5 col-sm-12">
                                        <div className="service-about-left">
                                            <div className="mt-media">
                                                <img src={require('./../../images/projects/img169.jpg')} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-7 col-sm-12">
                                        <div className="service-about-right m-b30">
                                            <h3 className="m-t0">Providing the latest innovations &amp; technologies with quality.</h3> {/*[cite: 1] */}
                                            <p>Established in January 2021, ECOSPARK ENGINEERING PLC is an electro-mechanical manufacturing and installation firm.[cite: 1] We specialize in the supply and management of water, design and implementation of electro-mechanical activities for small and high-scale projects, and the construction sector.[cite: 1] Our focus is to provide affordable, user-friendly, and high-quality technological innovations to our customers.[cite: 1]</p>
                                            <div className="call-for-quote-outer">
                                                <div className="call-quote">
                                                    <span>Call For a Quote:</span>
                                                    <h4>+251 924906565</h4> {/*[cite: 1] */}
                                                </div>
                                                <div className="call-estimate bg-dark">
                                                    <NavLink to={"/contactus"} className="site-button-secondry btn-effect">Online Estimate Form</NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default AboutCompany;